import { AxiosResponse } from "axios";

export const parseApiResponse = async (request: Promise<AxiosResponse<any, any>>): Promise<any> => {
	return (await request).data;
};
